export default function formatFilename(filename) {
  if (!filename) return '';

  return filename
    .toLowerCase()
    .replace(/\s/g, '-')
    .replace(/\/|\(|\)/g, '');
}
